const featureTesting = {
  getTestResult(modernizrFeatureName: string): unknown {
    if (typeof window !== 'undefined' && typeof window.Modernizr !== 'undefined') {
      return window.Modernizr[modernizrFeatureName];
    }
  },
};
export default featureTesting;
